// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ICatchUpElectionPropertyDto
 */
export interface ICatchUpElectionPropertyDto {
    /**
     * 
     * @type {number}
     * @memberof ICatchUpElectionPropertyDto
     */
    catch_up_election?: number;
    /**
     * 
     * @type {string}
     * @memberof ICatchUpElectionPropertyDto
     */
    catch_up_election_state?: ICatchUpElectionPropertyDtoCatchUpElectionStateEnum;
}

/**
* @export
* @enum {string}
*/
export enum ICatchUpElectionPropertyDtoCatchUpElectionStateEnum {
    MODIFIABLE = 'MODIFIABLE',
    LOCKED = 'LOCKED',
    HIDDEN = 'HIDDEN',
    REQUIRED_AT_PLAN = 'REQUIRED_AT_PLAN',
    REQUIRED_AT_ALL_LEVELS = 'REQUIRED_AT_ALL_LEVELS'
}


/**
 * Check if a given object implements the ICatchUpElectionPropertyDto interface.
 */
export function instanceOfICatchUpElectionPropertyDto(value: object): value is ICatchUpElectionPropertyDto {
    return true;
}

export function ICatchUpElectionPropertyDtoFromJSON(json: any): ICatchUpElectionPropertyDto {
    return ICatchUpElectionPropertyDtoFromJSONTyped(json, false);
}

export function ICatchUpElectionPropertyDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ICatchUpElectionPropertyDto {
    if (json == null) {
        return json;
    }
    return {
        
        'catch_up_election': json['catch_up_election'] == null ? undefined : json['catch_up_election'],
        'catch_up_election_state': json['catch_up_election_state'] == null ? undefined : json['catch_up_election_state'],
    };
}

export function ICatchUpElectionPropertyDtoToJSON(json: any): ICatchUpElectionPropertyDto {
    return ICatchUpElectionPropertyDtoToJSONTyped(json, false);
}

export function ICatchUpElectionPropertyDtoToJSONTyped(value?: ICatchUpElectionPropertyDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'catch_up_election': value['catch_up_election'],
        'catch_up_election_state': value['catch_up_election_state'],
    };
}

